import * as g from './../../../globals';
import { ShoppingCartService } from './../shoppingCart.service';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
  HostListener,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import {
  DeleteItemParams,
  NavigationData,
  ShoppingProducts,
  TableTitles,
  defaultTableTitles,
} from '../interfaces/ShoppingProductsItem';
import { ShoppingCartConfiguration } from '../interfaces/configuration';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { LayoutService } from 'src/app/layout/layout.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { tap } from 'rxjs/operators';
import { ShoppingCartQueue } from '../interfaces/shoppingCartQueue';
import { Subscription } from 'rxjs';
import { CartObject, Line } from '../interfaces/cartObject';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Clipboard } from '@angular/cdk/clipboard';
import { VariantSelectorComponent } from '../variant-selector/variant-selector.component';

@Component({
  selector: 'app-cart-products',
  templateUrl: './cartProducts.component.html',
  styleUrls: ['./cartProducts.component.less'],
})
export class CartProductsComponent implements OnInit, OnDestroy {
  @ViewChild('tableContainer') tableContainer: ElementRef;
  @ViewChild('cardsContainer') cardsContainer: ElementRef;

  productsVal: ShoppingProducts[];
  itemsInCart: Set<string>;
  @Input() set products(val: ShoppingProducts[]) {
    if (val == null) return;
    this.productsVal = val;
    this.itemsInCart = new Set<string>(
      this.productsVal
        .filter(
          (p) =>
            (p.SelectedQuantity != null && p.SelectedQuantity !== 0) ||
            (p.Quantity != null && p.Quantity !== 0),
        )
        .map((p) => p.ItemCode),
    );

    /*console.log({
      'ShoppingCartService.scrollShoppingItemToTop':
        ShoppingCartService.scrollShoppingItemToTop,
    });*/
    if (this.tableContainer && ShoppingCartService.scrollShoppingItemToTop) {
      //console.log(this.tableContainer.nativeElement);
      //console.log(this.tableContainer.nativeElement.scrollTop);
      //this.tableContainer.nativeElement.scrollTop = 0;

      const tableBody =
        this.tableContainer.nativeElement.querySelector('.ant-table-body');

      if (tableBody) {
        tableBody.scrollTop = 0;
      }

      ShoppingCartService.scrollShoppingItemToTop = false;
    }

    if (this.cardsContainer && ShoppingCartService.scrollShoppingItemToTop) {
      //console.log(this.cardsContainer.nativeElement);
      //console.log(this.cardsContainer.nativeElement.scrollTop);
      this.cardsContainer.nativeElement.scrollTop = 0;
      ShoppingCartService.scrollShoppingItemToTop = false;
    }
  }

  get products() {
    return this.productsVal;
  }
  @Input() cart: CartObject;
  @Input() TableColumns: TableTitles[] = defaultTableTitles;
  @Input() isTable = false;
  @Input() DocEntry?: number;
  @Input() CardCode?: any;
  @Input() customer?: any;
  @Input() dbShoppingCart = '1';

  @Input() forceEnableQtyInputs = false;
  @Output() onProductQuantityChanged = new EventEmitter();
  @Output() onProductWarehouseChanged = new EventEmitter();
  productsLoadingVal = false;
  @Input() set productsLoading(value: boolean) {
    this.productsLoadingVal = value;
    this.productsLoadingChange.emit(value);
  }

  get productsLoading() {
    return this.productsLoadingVal;
  }

  categoriesValue: Array<NavigationData> = [];
  allProductsMenuIsVisible = false;
  @Input() set categories(val: Array<NavigationData>) {
    this.categoriesValue = val;
    this.allProductsMenuIsVisible =
      this.categories.filter((c) => c.ShowOnTop).length > 0;
  }

  get categories() {
    return this.categoriesValue;
  }

  @Output() productsLoadingChange = new EventEmitter();
  @Input() contactCode?: number;
  @Input() config: ShoppingCartConfiguration = {
    EditableUnitPriceField: 'N',
    UpateQuantityOnKeyboard: 'Y',
    supportFreeGoodsLogic: false,
    totalLabel: '',
    CheckoutWarningMsg: '',
    AllowAddOutofStockItems: false,
    BlockAddingBelowMinimum: false,
    BlockAddingBelowMaximum: false,
    EnableQuantityMultiRule: false,
    OutOfStockErrorMsg: '',
    OutOfStockWarningMsg: '',
    DisplayCheckoutConfirmMsg: false,
    CheckoutConfirmMsg: '',
    ExtraMessageForDraft: '',
    AllowUpdateQuantityInCheckout: true,
    AllowSavingAsDraftEP: true,
    AllowSavingAsDraftCP: true,
    AllowExportToExcelEP: false,
    AllowExportToExcelCP: false,
  };
  isLoading = false;
  product: ShoppingProducts;
  isQuantityDisabled = false;
  baseUrl = g.apiBaseUrl;
  suffex;
  @ViewChild('detailsTemp', { static: false }) drawerTemplate?: TemplateRef<{
    $implicit: { value: string };
    drawerRef: NzDrawerRef<string>;
  }>;
  cardVertical = 'Y';
  containerHeight = 0;
  subscriptions: Subscription[] = [];

  tokenLink: string;
  isTokenModalVisible = false;

  productDrawer: NzDrawerRef;

  uomEditable = false;
  checkUomWhenAddingToCart = false;

  whsEditable = false;

  constructor(
    private SCService: ShoppingCartService,
    private drawerService: NzDrawerService,
    private notification: NzNotificationService,
    private layoutService: LayoutService,
    private clipboard: Clipboard,
    private message: NzMessageService,
  ) {
    this.layoutService.closeDrawer.subscribe((data) => {
      this.productDrawer.close();
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.onScreenResize();
  }

  onScreenResize() {
    const mainContent = window.document.getElementsByClassName(
      'shopping-cart-main-content',
    )[0];
    this.containerHeight = mainContent != null ? mainContent.clientHeight : 0;
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    if (innerWidth <= 762 || innerHeight < 800) {
      this.containerHeight = this.containerHeight - 125;
    } else {
      if (this.allProductsMenuIsVisible) {
        this.containerHeight = this.containerHeight - 200;
      } else {
        this.containerHeight = this.containerHeight - 125;
      }
    }
  }

  ngOnInit() {
    setInterval(() => {
      this.onScreenResize();
    }, 500);

    this.getTableColumns();

    this.suffex = g.getUrlSuffix();
    const getConfig$ = this.SCService.getConfiguration(
      'CardDirection',
    ).subscribe((response) => {
      this.cardVertical = response as string;
    });
    this.subscriptions.push(getConfig$);

    this.uomEditable = g.allowModifyUOMInSC;
    this.checkUomWhenAddingToCart = g.checkUOMInSC;

    this.whsEditable = g.allowModifyWHSInSC;
  }

  getTableColumns() {
    this.SCService.getItemsTableTitles(+this.dbShoppingCart)
      .pipe(tap((d) => (this.TableColumns = d.filter((c) => c.Visible))))
      .subscribe((data) => {});
  }

  openItemDetails(itemCode) {
    // const linkedModule = 4;
    // RecordPageComponent.openRecordPage(this.drawerService, {
    //   actionType: 'Edit',
    //   drawerTitle:
    //     this.layoutService.translate('Details of product: ') + itemCode,
    //   inDrawer: true,
    //   moduleId: linkedModule,
    //   parentComponent: this,
    //   recordId: itemCode,
    //   recordModel: undefined,
    // });
    this.productDrawer = this.drawerService.create({
      nzContent: ProductDetailsComponent,
      nzContentParams: {
        product: this.products.find((x) => x.ItemCode == itemCode),
        CardCode: this.CardCode,
        dbShoppingCart: this.dbShoppingCart,
        cart: this.cart,
        customer: this.customer,
        TableColumns: this.TableColumns,
        isTokenized: false,
        footerAtTop: false,
        inDrawer: true,
      },
      nzWrapClassName: 'drawer-size-4x',
    });
  }

  executeLineAction(item: ShoppingProducts, actionCode: string) {
    console.log(item.Price);
    console.log(actionCode);

    this.layoutService
      .pushDataToBackend(JSON.stringify(item), actionCode, JSON.stringify(item))
      .subscribe((response: any) => {
        let res = JSON.parse(response.Resault_Value);
        if (res.Has_Error) {
        } else {
        }
      });
  }

  async variantHandlerEmit(item: ShoppingProducts) {
    await this.onQuantityChanged(item, item.SelectedQuantity, this.CardCode, false, false, true);
  }
  async onQuantityChanged(
    item: ShoppingProducts,
    newQuantity,
    cardCode,
    fromPlusMinusButtons = false,
    fromVariant = false,
    openVariantIfNeeded = false,
  ) {
    if (newQuantity == null) {
      return;
    }

    if (!fromVariant && item.Configurable === 'Y') {
      const drawerRef = this.drawerService.create({
        nzTitle: this.layoutService.translate('View details'),
        nzContent: VariantSelectorComponent,
        nzMaskClosable: false,
        nzClosable: false,
        nzWrapClassName: 'drawer-size-4x',
        nzContentParams: {
          jsonData: item.JsonData,
          onQuantityChanged: async (
            variant: any,
            newQuantity: number,
            fromPlusMinusButtons = false,
            fromVariant?: boolean,
          ) => {
            const payloadItem: ShoppingProducts = {
              ...item,
              ItemCode: variant.ItemCode,
              SelectedQuantity: newQuantity,
              Quantity: newQuantity,
              LineNum: variant.LineNum ?? -1,
            };

            await this.onQuantityChanged(
              payloadItem,
              newQuantity,
              cardCode,
              fromPlusMinusButtons,
              fromVariant,
            );
          },
        },
      });

      drawerRef.afterClose.subscribe((result: any[] | null) => {
        if (!result) {
          return;
        }

        item.JsonData = JSON.stringify(result);
        item.SelectedQuantity = result.reduce(
          (sum, x) => sum + Number(x.SelectedQuantity || 0),
          0,
        );
      });
      return;
    }

    if (
      this.checkUomWhenAddingToCart &&
      (item['Unit'] == null || item['Unit'] === undefined)
    ) {
      this.notification.create(
        'error',
        this.layoutService.translate('Operation failed'),
        'Please select a uom',
      );
      return;
    }

    this.isQuantityDisabled = true;

    try {
      newQuantity = window['ValidateShoppingCartLineBeforeAdd'](
        this.dbShoppingCart,
        item,
        newQuantity,
      );
    } catch (e) {}

    if (
      item.MultOrdQty != null &&
      item.MultOrdQty !== 0 &&
      item.MultOrdQty !== 1 &&
      fromPlusMinusButtons
    ) {
      if (newQuantity < item.SelectedQuantity) {
        newQuantity = item.SelectedQuantity - item.MultOrdQty;
      } else {
        newQuantity = item.SelectedQuantity + item.MultOrdQty;
      }
    }
    if (newQuantity < 0) {
      this.notification.warning(
        this.layoutService.translate('Quantity cannot be negative'),
        this.layoutService.translate('Please enter a valid quantity'),
      );
      this.products.find((x) => x.ItemCode === item.ItemCode).SelectedQuantity =
        0;
      this.itemsInCart.delete(item.ItemCode);
      newQuantity = 0;
      this.SCService.UpdateLines.emit({
        data: { productId: item.ItemCode },
        item: item,
      });
      this.SCService.quantityUpdated.emit();
      this.SCService.warrentyHandler.emit(item);
      this.SCService.snChooserHandler.emit(item);
      if (openVariantIfNeeded) {
        this.SCService.customVariantHandler.emit(item);
      }
      //this.SCService.warehouseSelectorHandler.emit(item);
      this.isQuantityDisabled = false;
    }
    if (
      (item.SelectedQuantity === 0 || item.SelectedQuantity == null) &&
      newQuantity !== '' &&
      newQuantity !== 0 &&
      item.MinOrdrQty != null
    ) {
      newQuantity = item.MinOrdrQty;
    } else if (
      item.SelectedQuantity !== 0 &&
      item.SelectedQuantity == null &&
      item.MultOrdQty != null &&
      item.MultOrdQty !== 0 &&
      item.MultOrdQty !== 1 &&
      newQuantity !== '' &&
      newQuantity !== 0
    ) {
      newQuantity = item.SelectedQuantity + item.MultOrdQty;
    }

    newQuantity = newQuantity ? +newQuantity : 0;

    const result = await this.SCService.checkProductBeforeAddingToCart(
      this.dbShoppingCart,
      item,
      newQuantity,
      this.config,
    );

    item.ManualWhs = false;

    if (!result.isValid) {
      this.notification.create(
        'error',
        this.layoutService.translate('Operation failed'),
        result.message,
      );

      this.isQuantityDisabled = false;
      item.SelectedQuantity = item.Quantity;
      return;
    } else {
      item.SelectedQuantity = result.validQuantity;
      if (result.message !== '') {
        this.notification.create(
          'info',
          this.layoutService.translate(''),
          result.message,
        );
      }

      this.productsLoading = true;
    }

    if (cardCode instanceof Array) {
      this.CardCode = cardCode[0];
    } else {
      this.CardCode = cardCode;
    }

    // if this component is used out of the shopping cart
    if (this.forceEnableQtyInputs) {
      this.onProductQuantityChanged.emit({ item, newQuantity });
      this.productsLoading = false;
      return;
    }

    if (item.SelectedQuantity == 0) {
      if (this.cart == null) {
        this.productsLoading = false;
        this.isQuantityDisabled = false;
        return;
      }
      let line = this.cart.Lines.find((c) => c.ItemCode === item.ItemCode);
      if (line == null) {
        this.productsLoading = false;
        this.isQuantityDisabled = false;
        return;
      }
      this.deleteItem(line);
    } else {
      if (cardCode instanceof Array) {
        this.CardCode = cardCode[0];
      } else {
        this.CardCode = cardCode;
      }

      const queue$ = this.SCService.queueToUpdate(
        this.dbShoppingCart,
        {
          DocEntry: this.DocEntry.toString(),
          CardCode: this.CardCode,
          CntctCode: this.contactCode,
          QueueToUpdate: [item],
        },
        null,
      ).subscribe((data: any) => {
        if (!data.Has_Error) {
          this.isQuantityDisabled = false;
          this.SCService.UpdateLines.emit({ data: data, item: item });
          this.SCService.quantityUpdated.emit();
          this.SCService.warrentyHandler.emit(item);
          this.SCService.snChooserHandler.emit(item);
          if (openVariantIfNeeded) {
            this.SCService.customVariantHandler.emit(item);
          }
          //this.SCService.warehouseSelectorHandler.emit(item);
          if (!this.itemsInCart.has(item.ItemCode)) {
            this.itemsInCart.add(item.ItemCode);
          }
          if (
            this.itemsInCart.has(item.ItemCode) &&
            item.SelectedQuantity === 0
          ) {
            this.itemsInCart.delete(item.ItemCode);
          }
        } else {
          this.notification.error(
            this.layoutService.translate('Operation failed'),
            data.Error_Message,
          );
          // item.SelectedQuantity = 0;
          item.SelectedQuantity = item.Quantity;
          this.isQuantityDisabled = false;
        }
      });
      this.subscriptions.push(queue$);
    }
    this.productsLoading = false;
  }

  deleteItem(item: Line) {
    const params: DeleteItemParams = {
      billingAddress: this.cart.PayToCode,
      cardCode: this.customer.CardCode,
      contactPerson: this.cart.Identity.ContactPerson.toString(),
      day: 0,
      docEntry: this.cart.DocEntry,
      itemCode: item.ItemCode,
      lineNume: item.LineNum,
      month: 0,
      year: 0,
      shippingAddress: this.cart.ShipToCode,
    };

    this.SCService.DeleteItem(params)
      .pipe(
        tap((deleteData) => {
          this.SCService.UpdateLines.emit({ data: true });
          this.SCService.quantityUpdated.emit();
          console.log('deleteData', deleteData);
          this.isQuantityDisabled = false;
        }),
      )
      .subscribe();
  }

  inputKeyPress(event) {
    const pattern = /[a-z]/;
    const inputChar = event.key;
    if (pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getOptions(tableRow, column: TableTitles, columnName = '') {
    if (column === undefined && columnName === 'SUomEntry') {
      column = this.TableColumns.find((tc) => tc.Name === 'SUomEntry');
    }

    if (column === undefined && columnName === 'WhsCode') {
      column = this.TableColumns.find((tc) => tc.Name === 'WhsCode');
    }

    const paramsNames = g.queriesData[column.SQLStatementId];
    console.log(paramsNames);

    if (
      (paramsNames === undefined || paramsNames.length === 0) &&
      column.Options != null &&
      column.Options.length !== 0
    ) {
      return;
    }

    if (tableRow.Options != null && tableRow.Options.length !== 0) {
      column.Options = tableRow.Options;
      return;
    }

    const listOfParamFields = g.uomQueryParamFields
      ?.split(',')
      .map((f) => f.trim())
      .filter((f) => f); // remove empty entries

    const params = listOfParamFields.reduce((acc, field) => {
      const value = tableRow[field];

      if (value !== null && value !== undefined) {
        acc[`SC.${field}`] = value;
      }

      return acc;
    }, {} as any);

    this.isLoading = true;

    this.layoutService
      .executeQuery(column.SQLStatementId, params)
      .subscribe((d: any) => {
        if (d === null || d === undefined) {
          this.isLoading = false;
          return;
        }
        column.Options = d;
        tableRow.Options = d;
        this.isLoading = false;
      });
  }

  openDetailsDrawer(tableRow) {
    this.product = tableRow;
    const drawerRef = this.drawerService.create({
      nzTitle: 'Product Details',
      nzContent: this.drawerTemplate,
      nzWrapClassName: 'drawer-size-5x',
    });

    const drawerClose$ = drawerRef.afterClose.subscribe(() => {
      this.product = null;
    });
    this.subscriptions.push(drawerClose$);
  }

  onBlur(field, tableRow, columnName: string) {
    tableRow.ManualWhs = false;
    const queueToUpdate: ShoppingCartQueue = {
      ...tableRow,
    };
    //const key = columnName.Name;
    const key = columnName;
    const value = tableRow[key];
    if (key.startsWith('U_')) {
      queueToUpdate.UserFieldsLines = [];
      queueToUpdate.UserFieldsLines.push({ Key: key, Value: value });
    }
    // queueToUpdate.UserFieldsLines[key] = value;

    if (columnName === 'SUomEntry') {
      const column = this.TableColumns.find((tc) => tc.Name === 'SUomEntry');
      tableRow['Unit'] = column.Options.find(
        (op) => op.Code.toString() === value.toString(),
      ).Name;
    }

    if (columnName === 'U_WhsCode' || columnName === 'WhsCode') {
      queueToUpdate.ManualWhs = true;
    }

    if (tableRow.SelectedQuantity === 0 || tableRow.SelectedQuantity == null) {
      return;
    }

    if (this.CardCode instanceof Array) {
      this.CardCode = this.CardCode[0];
    } else {
      this.CardCode = this.CardCode;
    }

    if (tableRow != null) {
      if (this.forceEnableQtyInputs) {
        this.onProductWarehouseChanged.emit({ queueToUpdate });
        this.productsLoading = false;
        return;
      }

      const queue$ = this.SCService.queueToUpdate(
        this.dbShoppingCart,
        {
          DocEntry: this.DocEntry.toString(),
          CardCode: this.CardCode,
          CntctCode: this.contactCode,
          QueueToUpdate: [queueToUpdate],
        },
        null,
      )
        .pipe(tap((response) => {}))
        .subscribe(() => {
          this.SCService.fieldUpdated.emit(1);
          this.SCService.quantityUpdated.emit();
        });
      this.subscriptions.push(queue$);
    }
  }
  trackByItemCode(index, item) {
    return item.ItemCode;
  }

  GenerateToken(itemCode) {
    this.SCService.GenerateToken(
      4,
      'OBJECT_TYPE',
      itemCode,
      g.getToken(),
    ).subscribe((x: any) => {
      const BaseUrl = x.Resault_Value.AngularBaseUrl;
      const Token = x.Resault_Value.Token;
      this.tokenLink = `${BaseUrl}apps/documents/index?token=${Token}&App=ITM-TOKENIZ&language=${g.language}`;
      this.isTokenModalVisible = true;
    });
  }

  copyTokenLink() {
    this.clipboard.copy(this.tokenLink);
    this.message.info('Link copied to the clipboard');
  }
}
